import { render, staticRenderFns } from "./EditServiceCooperation.vue?vue&type=template&id=35efca1b&scoped=true"
import script from "./EditServiceCooperation.vue?vue&type=script&lang=js"
export * from "./EditServiceCooperation.vue?vue&type=script&lang=js"
import style0 from "./EditServiceCooperation.vue?vue&type=style&index=0&id=35efca1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35efca1b",
  null
  
)

export default component.exports